import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';

import { getEstimationItemStyle, getDisplayPlusCampaignEstimationItemStyle } from './styles/get-estimation-item-styles';

export const EstimationItem = (props) => {
  const {
    className,
    title,
    dashColor,
    estimation,
    isDisplayPlusCampaign,
  } = props;

  const classes = useDefaultStyles(isDisplayPlusCampaign ? getDisplayPlusCampaignEstimationItemStyle : getEstimationItemStyle);
  const estimationText = _.isArray(estimation) ? `${estimation[0]} - ${estimation[1]}` : estimation;

  return (
    <div className={classNames('item-container', classes.itemContainer)}>
      <div className="item-title">
        {title}
      </div>
      <div
        className="item-dash"
        style={{
          borderColor: dashColor,
          background: dashColor,
        }}
      />
      <div className={classNames('item-estimation', className)}>
        {estimationText}
      </div>
    </div>
  );
};

EstimationItem.propTypes = {
  className: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  dashColor: PropTypes.string.isRequired,
  estimation: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.arrayOf(PropTypes.number),
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]).isRequired,
};
